import { FactoryTypes, FieldID } from "../../../models";

export const iphoneSetupContentWithPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.downloadMoveToiOSApp.text,
            image: FieldID.guideContainer.steps.downloadMoveToiOSApp.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .turnOniPhoneAndMoveDataFromAndroid.text,
            image:
              FieldID.guideContainer.steps.turnOniPhoneAndMoveDataFromAndroid
                .image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.enteriPhoneVerificationCode.text,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.selectContentAndTransferData
              .text,
            image:
              FieldID.guideContainer.steps.selectContentAndTransferData.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.waitUntilLoadingCompletes.text,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .tapContinueAndFollowRemainingSteps.text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];

export const iphoneSetupContentLostPhone = [
  {
    type: FactoryTypes.TIPBOX,
    fieldMapping: {
      text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
      icon: FieldID.guideContainer.tipBox.icon,
    },
  },
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        {
          type: FactoryTypes.STEP,
          fieldMapping: {
            text: FieldID.guideContainer.decisionStep.proceedToNextStep,
          },
        },
      ],
      noSteps: [
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.appleSetupQuickStart.text,
            image: FieldID.guideContainer.steps.appleSetupQuickStart.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhoneSetupLostPhoneTransferApps
              .text,
            image:
              FieldID.guideContainer.steps.iPhoneSetupLostPhoneTransferApps
                .image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhoneSetupLostPhoneSetupAppleId
              .text,
            image:
              FieldID.guideContainer.steps.iPhoneSetupLostPhoneSetupAppleId
                .image,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ],
    },
  },
];
